import React from 'react'

const SocialMediaLinks = ({ flexDirection , className }) => {
  return (
    <div className={`${flexDirection} ${className} d-flex`}>
         <a 
               href="https://web.facebook.com/olawale.adekeye.35/" 
               className="fab fa-facebook text-center m-0"
                data-bs-toggle='tooltip' title='facebook'
                target={'_blank'}
           ></a>
         <a 
             href="https://api.whatsapp.com/send?phone=2348142746379&text=%20Hello%20Abdulrahaman"
              className="fab fa-whatsapp text-center m-0"
              data-bs-toggle='tooltip' title='whatsapp'
              target={'_blank'}
              >  </a>
         <a href="https://www.linkedin.com/in/abdulrahman-adekeye-a19979145/"
          className="fab fa-linkedin text-center m-0"
          data-bs-toggle='tooltip' title='linkedin'
          target={'_blank'}
          ></a>
         <a href="https://www.github.com/Abdulrahaman1000" 
         className="fab fa-github text-center m-0"
         data-bs-toggle='tooltip' title='github'
         target={'_blank'}
         ></a>        
    </div>
  )
}

export default SocialMediaLinks